import {UserInfo} from "../models/User";
import {formatFamilyGivenName} from "./formatFullName";

export const nameSortFunc = (a: UserInfo | null, b: UserInfo | null, order: "asc" | "desc" = "asc") => (
    (order === "asc") ? formatFamilyGivenName(a).localeCompare(formatFamilyGivenName(b))
                      : formatFamilyGivenName(b).localeCompare(formatFamilyGivenName(a))
);
